const differentiators = [
  {
    iconClass: 'fas fa-handshake',
    title: 'Data You Can Trust',
    description:
      'OpenPharma maintains continuously reconciled, structured data aligned to your ERP, delivering a reliable single source of truth Market Access and Finance teams can confidently depend on.',
  },
  {
    iconClass: 'fas fa-plug',
    title: 'Seamless Integration',
    description:
      'OpenPharma integrates effortlessly with your existing ERP and RCM solutions, closing workflow gaps and enabling your team to focus on higher‑value analysis that drives business outcomes.',
  },
  {
    iconClass: 'fas fa-shield-alt',
    title: 'Compliance',
    description:
      'SOC 1 and SOC 2 Type II compliant, OpenPharma’s controls are purpose‑built for SOX alignment, ensuring every workflow is secure, traceable, and audit‑ready.',
  },
  {
    iconClass: 'fas fa-bolt',
    title: 'Fast Implementation',
    description:
      'OpenPharma connects easily with leading RCM and ERP platforms, accelerating adoption while minimizing disruption and change management effort.',
  },
  {
    iconClass: 'fas fa-check-circle',
    title: 'Validation Engine',
    description:
      'Powered by hundreds of configurable validations, OpenPharma performs rigorous scrubbing at both summary and script‑level detail—delivering unmatched accuracy and confidence.',
  },
  {
    iconClass: 'fas fa-chart-bar',
    title: 'Visualization & Insights',
    description:
      'Powering dashboards, ad hoc perspectives, Excel, Power BI, and Tableau, OpenPharma data visualization provides critical insights into financial analysis and market access operations.',
  },
];

export default differentiators;
